import React from "react";
import Paper from "@material-ui/core/Paper";
import {paper_style} from "./styles";
import Container from "@material-ui/core/Container";
import BackButton from "./Buttons/BackButton"
import Geocode from "react-geocode";
import { LoopCircleLoading } from "react-loadingg";


class MapsPage extends React.Component{
    constructor(props) {
        super(props);
        this.state ={
            lat:"",
            lon:"",
            isLoading:true
        }
        this.getLanLon = this.getLanLon.bind(this);
    }

    getLanLon(city){
        Geocode.setApiKey("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx");
        Geocode.setLanguage("en");
        Geocode.enableDebug();
        Geocode.fromAddress("Eiffel Tower").then(
            response => {
                const { lat, lon } = response.results[0].geometry.location;
                console.log("yay!" + lat + lon)
                // this.setState({
                //     lat:lat,
                //     lon:lon,
                //     isLoading:false
                // })
            },
            error => {
            console.error("error");
            this.setState({
                isLoading:false
            })
            }
        );
    }

    render() {
        const location = this.props.location.state.city;
        console.log(location);
        let lat, lon = this.getLanLon(location);
        return (
            <Container component="main" maxWidth="xs">
                <Paper style={paper_style}>
                    {this.state.isLoading ? (
                    <LoopCircleLoading />
                    ) : (
                        <div>
                        <BackButton/>
                        <h1>maps</h1>
                        <div><a href={"https://www.google.com/maps/?q=" + lat + "," +lon} target="_blank">google maps</a></div>
                        <div><a href={`https://waze.com/ul?ll=${lat},${lon}&navigate=yes`} target="_blank">waze</a></div>
                        </div>
                    )}
                    
                </Paper>
            </Container>  
        );
    }
}

export default MapsPage;